/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { FiShield } from "react-icons/fi";
import { useUI } from "../theme/ThemeProvider";

export default function NoAccess() {
  const { theme, lang, colors } = useUI();
  const isDark = theme === "dark";
  const isArabic = lang === "ar";

  return (
    <div
      className="flex items-center justify-center min-h-[80vh] px-4"
    >
      <div className="text-center max-w-md mx-auto p-6 sm:p-8 bg-white/5 dark:bg-white/[0.02] backdrop-blur-lg rounded-3xl border border-gray-200/20 dark:border-white/5 shadow-xl animate-in zoom-in duration-500">
        <div
          className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl flex items-center justify-center mx-auto mb-6 rotate-12 shadow-inner"
          style={{
            backgroundColor: isDark ? "rgba(239, 68, 68, 0.15)" : "rgba(239, 68, 68, 0.08)",
          }}
        >
          <FiShield className="sm:text-5xl text-4xl" style={{ color: "#EF4444" }} />
        </div>
        <h1
          className="text-xl sm:text-2xl font-black mb-4 tracking-tight"
          style={{ color: colors.text }}
        >
          {isArabic ? "غير مصرح بالوصول" : "Access Denied"}
        </h1>
        <p
          className="text-sm sm:text-base leading-relaxed"
          style={{ color: colors.subText }}
        >
          {isArabic
            ? "ليس لديك صلاحية لعرض هذه الصفحة. يرجى الاتصال بالمسؤول لطلب الصلاحيات اللازمة."
            : "You don't have permission to view this page. Please contact the administrator to request access."}
        </p>
      </div>
    </div>
  );
}

